import { render, staticRenderFns } from "./IconMailSolid.vue?vue&type=template&id=13e32b7c"
import script from "./IconMailSolid.vue?vue&type=script&lang=js"
export * from "./IconMailSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports